import { createContext, useContext } from "react";

export const WaitlistContext = createContext<{
  onStartFree: () => void;
  /** True from a CTA tap until the lazily loaded dialog chunk has arrived. */
  pending: boolean;
}>({
  onStartFree: () => {},
  pending: false,
});

export function useWaitlist() {
  return useContext(WaitlistContext);
}
